interface Props {
  t: (key: string) => string;
}

const CTA_URL = 'https://wa.me/5519997391955';

export function FinalCTA({ t }: Props) {
  return (
    <section className="final" id="contato">
      <div className="final-orb"></div>
      <div className="container">
        <h2 className="reveal">
          {t('final.h2.a')} <span className="em">{t('final.h2.em')}</span>
        </h2>
        <p className="reveal">{t('final.body')}</p>
        <div className="cta-wrap reveal">
          <a className="btn btn-primary" href={CTA_URL} target="_blank" rel="noopener noreferrer">
            {t('final.cta')} <span className="arr">→</span>
          </a>
          <div className="disclaimer">{t('final.disclaimer')}</div>
        </div>
      </div>
    </section>
  );
}
